import { React, useEffect, useRef, useState } from "react";
import { FaRegThumbsUp, FaRegThumbsDown, GrShareOption } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "../styles/Card.css";
import prof from "../images/aayush.png";
// import { useSpeechSynthesis } from "react-speech-kit";

const PostCard = ({
  post,
  onLike,
  onDislike,
  likesCount,
  dislikesCount,
  timeDifference,
  profileimg,
  postimg,
  category,
}) => {
  const navigate = useNavigate();
  const descriptionRef = useRef(null);
  const maxLines = 11;

  useEffect(() => {
    truncateDescription();
  }, [post.description]);

  const truncateDescription = () => {
    if (descriptionRef.current) {
      const lineHeight = parseInt(
        window.getComputedStyle(descriptionRef.current).lineHeight
      );
      const maxHeight = lineHeight * maxLines;

      if (descriptionRef.current.clientHeight > maxHeight) {
        descriptionRef.current.style.maxHeight = `${maxHeight}px`;
        descriptionRef.current.style.overflow = "hidden";
      }
    }
  };
  // const [isSpeaking, setIsSpeaking] = useState(false);
  // const { speak, cancel } = useSpeechSynthesis();

  // const handleSpeechToggle = () => {
  //   if (isSpeaking) {
  //     cancel();
  //     setIsSpeaking(false);
  //   } else {
  //     speak({ text: post.description });
  //     setIsSpeaking(true);
  //   }
  // };

  // useEffect(() => {
  //   const handleEnd = () => {
  //     setIsSpeaking(false);
  //   };

  //   if (isSpeaking) {
  //     speak({ text: post.description, onEnd: handleEnd });
  //   }

  //   return () => {
  //     cancel();
  //   };
  // }, [speak, cancel, post.description, isSpeaking]);

  const [isLiked, setIsLiked] = useState(false);
  const [isDisliked, setIsDisliked] = useState(false);
  // const [isSpeechActive, setIsSpeechActive] = useState(false);

  const handleLikeClick = (postId) => {
    onLike(postId);
    setIsLiked(!isLiked);
  };

  const handleDislikeClick = (postId) => {
    onDislike(postId);
    setIsDisliked(!isDisliked);
  };

  // const handleSpeechClick = () => {
  //   handleSpeechToggle();
  //   setIsSpeechActive(!isSpeechActive);
  // };

  return (
    <>
      <div className="w-full h-screen my-1">
        <div className="flex flex-col items-start w-full mx-auto bg-white md:w-1/3 rounded-xl">
          <div className="flex">
            <div className="media flex items-start ">
              <div className="media-body flex items-start gap-2.5">
                <div className="flex justify-start items-start rounded-full">
                  <img
                    src={prof}
                    className="no-repeat w-10 h-10 rounded-full"
                    alt="Profile"
                  />
                </div>
                <div className="flex flex-col items-start media-content">
                  <div className="flex items-center gap-2.5 self-stretch">
                    <div className="aayush_talreja text-black text-sm font-medium leading-6">
                      Username
                    </div>
                    <div className="flex items-start">
                      <svg
                        width={12}
                        height={12}
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M7.5 0C3.35795 0 0 3.35795 0 7.5C0 11.642 3.35795 15 7.5 15C11.642 15 15 11.642 15 7.5C15 3.35795 11.642 0 7.5 0ZM10.7509 6.23182C10.8108 6.16339 10.8563 6.08369 10.8849 5.99739C10.9135 5.91109 10.9246 5.81994 10.9175 5.72931C10.9103 5.63867 10.8851 5.55038 10.8433 5.46963C10.8016 5.38888 10.7441 5.3173 10.6742 5.2591C10.6044 5.20089 10.5236 5.15725 10.4367 5.13072C10.3497 5.1042 10.2583 5.09534 10.1679 5.10466C10.0774 5.11397 9.98978 5.14128 9.91005 5.18498C9.83033 5.22867 9.76015 5.28787 9.70364 5.35909L6.77182 8.87659L5.25477 7.35886C5.12618 7.23467 4.95395 7.16594 4.77518 7.1675C4.59641 7.16905 4.4254 7.24075 4.29899 7.36717C4.17257 7.49358 4.10087 7.66459 4.09931 7.84336C4.09776 8.02213 4.16648 8.19436 4.29068 8.32295L6.33614 10.3684C6.40313 10.4354 6.48334 10.4876 6.57165 10.5219C6.65996 10.5561 6.75443 10.5716 6.84905 10.5673C6.94366 10.563 7.03635 10.539 7.12119 10.4969C7.20603 10.4548 7.28117 10.3955 7.34182 10.3227L10.7509 6.23182Z"
                          fill="#1236F3"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="mumbai__india self-stretch text-[#6c757d] text-sm leading-1">
                    City, State
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-center self-stretch justify-center mt-4">
            <img
              src={postimg}
              className="unsplash_z9qoq6d_mkg lightgray 50% / no-repeat h-[12.625rem] rounded-lg"
              alt="Post"
            />
          </div>
          <div className="july_17__2018 text-[#6c757d] text-start flex w-full text-sm my-2 leading-5 justify-between">
            <span class="inline-flex items-center px-2 py-1 bg-gray-200 hover:bg-gray-300 rounded-lg text-xs font-semibold text-gray-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 32 32"
              >
                <circle cx="16" cy="16" r="8" fill="#6c6a6a" />
              </svg>
              {post.category}
            </span>
            <span class="inline-flex items-center px-2 py-1 bg-gray-200 hover:bg-gray-300 rounded-lg text-xs font-semibold text-gray-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 32 32"
              >
                <circle cx="16" cy="16" r="8" fill="#3178C6" />
              </svg>
              Status
            </span>
            {/* <span>{post.city}</span> */}
          </div>

          <div className="flex items-start font-['Roboto'] gap-2.5 self-stretch py-2 text-black  text-xl font-bold leading-[130%]">
            {post.title}
          </div>
          <div
            className="flex flex-col mx-0 text-md text-start text-sm justify-start self-stretch lorem_ipsum_dolor_sit_amet__consectetur_adipiscing_elit__sed_do_eiusmod_tempor_incididunt_ut_labore_et_dolore_magna_aliqua_ pr-1 text-black  leading-[1.4375rem] overflow-hidden"
            ref={descriptionRef}
          >
            {post.description}
          </div>
          <div className="july_17__2018 self-stretch text-[#6c757d] text-start  text-sm my-2 leading-5">
            {timeDifference[post._id] || "just now"}
          </div>
        </div>
      </div>
      {/* Sticky buttons */}
      <div className="fixed right-5 space-y-10 ml-1 my-auto z-[9999999] bottom-24">
        <div>
          <button
            onClick={() => handleLikeClick(post._id)}
            className='flex items-center shadow-none text-center text-[#006113]'
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              className={`rounded-full ${
                isLiked ? "bg-gray-300" : "bg-transparent"
              }`}
            >
              <path
                fill="#404040"
                d="M11 11.8V15q0 .425.288.713T12 16q.425 0 .713-.288T13 15v-3.2l.9.9q.275.275.7.275t.7-.275q.275-.275.275-.7t-.275-.7l-2.6-2.6q-.3-.3-.7-.3t-.7.3l-2.6 2.6q-.275.275-.275.7t.275.7q.275.275.7.275t.7-.275zM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8"
              />
            </svg>
            <span className="font-semibold">
              &nbsp;
              {likesCount}
            </span>
          </button>
        </div>
        <div>
          <button
            onClick={() => handleDislikeClick(post._id)}
            className="flex items-center shadow-none bg-transparent text-center text-red-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              className={`rounded-full ${
                isDisliked ? "bg-gray-300" : "bg-transparent"
              }`}
            >
              <path
                fill="#404040"
                d="m11 12.2l-.9-.9q-.275-.275-.7-.275t-.7.275q-.275.275-.275.7t.275.7l2.6 2.6q.3.3.7.3t.7-.3l2.6-2.6q.275-.275.275-.7t-.275-.7q-.275-.275-.7-.275t-.7.275l-.9.9V9q0-.425-.288-.712T12 8q-.425 0-.712.288T11 9zm1 9.8q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12q0-3.35-2.325-5.675T12 4Q8.65 4 6.325 6.325T4 12q0 3.35 2.325 5.675T12 20m0-8"
              />
            </svg>
            <span className="font-semibold">
              &nbsp;
              {dislikesCount}
            </span>
          </button>
        </div>
        <div>
          <button
            className="flex items-center shadow-none bg-transparent text-center"
            onClick={() => navigate(`/posts/${post._id}`)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 26 26"
            >
              <g fill="#404040">
                <path d="M8.707 18.707a1 1 0 0 1-1.414-1.414l4-4a1 1 0 1 1 1.414 1.414z" />
                <path d="M8 19a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2z" />
                <path d="M9 18a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0zm5.707-5.293a1 1 0 0 1-1.414-1.414l4-4a1 1 0 1 1 1.414 1.414z" />
                <path d="M19 12a1 1 0 1 1-2 0V8a1 1 0 1 1 2 0z" />
                <path d="M14 9a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2z" />
                <path
                  fill-rule="evenodd"
                  d="M13 24c6.075 0 11-4.925 11-11S19.075 2 13 2S2 6.925 2 13s4.925 11 11 11m0 2c7.18 0 13-5.82 13-13S20.18 0 13 0S0 5.82 0 13s5.82 13 13 13"
                  clip-rule="evenodd"
                />
              </g>
            </svg>
          </button>
        </div>
        <div>
          <button
             className='flex items-center shadow-none rounded-full text-center'
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="28"
              height="28"
              viewBox="0 0 26 26"
              className={`rounded-full ${
                isDisliked ? "bg-gray-300" : "bg-transparent"
              }`}
            >
              <g fill="#404040">
                <path
                  fill-rule="evenodd"
                  d="m13.334 4.754l-4.68 4.178H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h3.535l4.796 4.312c.644.578 1.669.122 1.669-.744v-15c0-.864-1.021-1.321-1.666-.746m-3.668 5.955L13 7.733v10.523l-3.126-2.81A1 1 0 0 0 9 14.932H6v-4h2.751c.302.079.642.02.915-.223"
                  clip-rule="evenodd"
                />
                <path d="M18.489 16.069a.75.75 0 1 1-.978-1.138c.034-.029.067-.06.1-.094c.138-.143.261-.324.362-.536A3.05 3.05 0 0 0 18.25 13c0-.754-.25-1.433-.639-1.837a1.488 1.488 0 0 0-.1-.094a.75.75 0 1 1 .978-1.138c.07.06.137.124.202.191c.67.696 1.059 1.75 1.059 2.878c0 .696-.147 1.366-.423 1.945c-.168.355-.383.67-.636.933a2.942 2.942 0 0 1-.202.19" />
                <path d="M19.411 19.127a.75.75 0 0 1-.822-1.254a6.032 6.032 0 0 0 1.304-1.16a5.91 5.91 0 0 0 .904-1.474a5.72 5.72 0 0 0 .425-2.813a5.732 5.732 0 0 0-1.329-3.14a5.968 5.968 0 0 0-1.304-1.159a.75.75 0 1 1 .822-1.254a7.51 7.51 0 0 1 2.071 2.03a7.32 7.32 0 0 1 .945 1.955a7.21 7.21 0 0 1 .287 2.865a7.248 7.248 0 0 1-2.166 4.49a7.515 7.515 0 0 1-1.137.914" />
                <path
                  fill-rule="evenodd"
                  d="M13 24c6.075 0 11-4.925 11-11S19.075 2 13 2S2 6.925 2 13s4.925 11 11 11m0 2c7.18 0 13-5.82 13-13S20.18 0 13 0S0 5.82 0 13s5.82 13 13 13"
                  clip-rule="evenodd"
                />
              </g>
            </svg>
          </button>
        </div>
        <div>
          <button className="flex items-center shadow-none bg-transparent text-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 24 24"
            >
              <path
                fill="#5e5e5e"
                d="M12 14a2 2 0 1 0 0-4a2 2 0 0 0 0 4m-6 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4m12 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4"
              />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default PostCard;